export enum ActiveFeedStatus {
	STATUS_UNSPECIFIED = 0,
	PENDING = 1,
	CONNECTED = 2,
	AUTH_FAILED = 3,
	DELAYED = 4,
	UNRESPONSIVE = 5,
	ACTION_NEEDED = 6,
}

export const INACTIVE_INTEGRATION_STATUS = 'Inactive' as const

export const ACTIVE_FEED_STATUS_LABELS: Record<ActiveFeedStatus | 'Inactive', string> = {
	[ ActiveFeedStatus.STATUS_UNSPECIFIED ]: 'Unspecified',
	[ ActiveFeedStatus.PENDING ]: 'Pending',
	[ ActiveFeedStatus.CONNECTED ]: 'Connected',
	[ ActiveFeedStatus.AUTH_FAILED ]: 'Authentication Needed',
	[ ActiveFeedStatus.DELAYED ]: 'Delayed',
	[ ActiveFeedStatus.UNRESPONSIVE ]: 'Unresponsive',
	[ ActiveFeedStatus.ACTION_NEEDED ]: 'Action Needed',
	[ INACTIVE_INTEGRATION_STATUS ]: 'Inactive',
}

export type IntegrationDetails = {
	name?: string | null,
	oemLogoUrl?: string | null,
	refreshIntervalMinutes?: number | null,
}

export type ActiveIntegration = {
	feedId: string,
	lastUpdate?: string | null,
	name: string,
	integration?: IntegrationDetails | null,
	nextUpdate?: string | null,
	currentStatus?: ActiveFeedStatus | null,
	isActive?: boolean | null,
	refreshIntervalMinutes?: number | null,
}
